import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import PasswordInput from "../components/PasswordInput";

export default function AdminForgot() {
  const [step, setStep] = useState(1); // 1: E-Mail, 2: Code + neues PW
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const requestCode = async (e) => {
    e.preventDefault();
    setError(""); setMessage("");
    setLoading(true);
    const { data } = await api.resetRequest(email);
    setLoading(false);
    if (data && data.ok) {
      setMessage("Falls die E-Mail bekannt ist, wurde ein 6-stelliger Code versendet. Bitte prüfe dein Postfach (auch Spam-Ordner).");
      setStep(2);
    } else {
      setError("Etwas ist schiefgelaufen. Bitte erneut versuchen.");
    }
  };

  const verifyAndSetPassword = async (e) => {
    e.preventDefault();
    setError(""); setMessage("");
    if (newPassword !== confirmPassword) {
      setError("Die beiden Passwörter stimmen nicht überein.");
      return;
    }
    if (newPassword.length < 8) {
      setError("Das neue Passwort muss mindestens 8 Zeichen lang sein.");
      return;
    }
    setLoading(true);
    const { data } = await api.resetVerify(email, code.trim(), newPassword);
    setLoading(false);
    if (data && data.ok) {
      setMessage("Passwort erfolgreich geändert! Du kannst dich jetzt mit dem neuen Passwort anmelden.");
      setTimeout(() => navigate("/admin/login", { replace: true }), 2000);
    } else {
      setError((data && data.message) || "Code ist ungültig oder abgelaufen.");
    }
  };

  return (
    <div className="admin-page" data-testid="admin-forgot-page">
      <div className="admin-card">
        <h1 className="admin-title">Passwort zurücksetzen</h1>

        {step === 1 && (
          <form onSubmit={requestCode} className="admin-form" data-testid="admin-forgot-request-form">
            <p className="admin-subtitle">Gib die hinterlegte E-Mail-Adresse ein. Wir senden dir dann einen 6-stelligen Code.</p>
            <label className="admin-label">
              E-Mail-Adresse
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                data-testid="admin-forgot-email-input"
              />
            </label>
            {error && <p className="admin-error">{error}</p>}
            {message && <p className="admin-success">{message}</p>}
            <button type="submit" className="admin-btn admin-btn-primary" disabled={loading} data-testid="admin-forgot-request-submit">
              {loading ? "Sende…" : "Code anfordern"}
            </button>
            <div className="admin-footer-links">
              <Link to="/admin/login">Zurück zum Login</Link>
            </div>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={verifyAndSetPassword} className="admin-form" data-testid="admin-forgot-verify-form">
            {message && <p className="admin-success">{message}</p>}
            <label className="admin-label">
              6-stelliger Code
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
                required
                data-testid="admin-forgot-code-input"
              />
            </label>
            <label className="admin-label">
              Neues Passwort (mind. 8 Zeichen)
              <PasswordInput
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
                data-testid="admin-forgot-new-password"
              />
            </label>
            <label className="admin-label">
              Passwort bestätigen
              <PasswordInput
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                autoComplete="new-password"
                data-testid="admin-forgot-confirm-password"
              />
            </label>
            {error && <p className="admin-error" data-testid="admin-forgot-verify-error">{error}</p>}
            <button type="submit" className="admin-btn admin-btn-primary" disabled={loading} data-testid="admin-forgot-verify-submit">
              {loading ? "Setze neues Passwort…" : "Passwort ändern"}
            </button>
            <div className="admin-footer-links">
              <button type="button" onClick={() => { setStep(1); setError(""); setMessage(""); }} className="admin-btn admin-btn-link">
                Anderen Code anfordern
              </button>
              <Link to="/admin/login">Zurück zum Login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
